<template>
  <DxDropDownButton
    :items="getItems"
    :keyExpr="keyExpr"
    :displayExpr="displayExpr"
    :drop-down-options="getDropDownOptions"
    class="gc-dropdown-icon-button"
    styling-mode="text"
    :show-arrow-icon="false"
    :onItemClick="onItemClick"
    :disabled="disabled"
    :icon="icon"
  />
</template>

<script>
export default {
  props: {
    menuOptions: {
      type: Object,
      default: () => {},

      // Example
      //   menuOptions: {
      //     items: [
      //       {
      //         text: "Print",
      //         icon: "print",
      //       },
      //     ],
      //     keyExpr: "text",
      //     displayExpr: "text",
      //   },
    },
    onItemClickCallBack: {
      type: Function,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: this.menuOptions ? this.menuOptions.items : [],
      keyExpr: this.menuOptions ? this.menuOptions.keyExpr : undefined,
      displayExpr: this.menuOptions ? this.menuOptions.displayExpr : undefined,
      icon: "overflow",
      id: "id",
    };
  },
  components: {},
  computed: {
    getDropDownOptions() {
      if (this.data.column.dropDownOptions)
        return this.data.column.dropDownOptions;
      else return { width: 200 };
    },
    getItems() {
      if (this.menuOptions && this.menuOptions.itemAction)
        return this.menuOptions.itemAction(this.data);
      else return this.menuOptions ? this.menuOptions.items : [];
    },
  },
  created() {},
  methods: {
    onItemClick(e) {
      this.onItemClickCallBack(this.data, e);
    },
  },
};
</script>

<style lang="scss">
.dx-button-content .dx-icon::before {
  color: rgba(148, 148, 148, 0.87);
}
</style>
